import { render } from "./Column202510.vue?vue&type=template&id=33d3a086&scoped=true"
import script from "./Column202510.vue?vue&type=script&lang=js"
export * from "./Column202510.vue?vue&type=script&lang=js"

import "./Column202510.vue?vue&type=style&index=0&id=33d3a086&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33d3a086"

export default script